<template>
    <div class="page">
        <query-form />
        <search-bar :rightList="rightListMap" />
        <!-- <div class="content"> -->
        <el-table :data="tableData" style="width: 100%" header-row-class-name="table-header" :row-class-name="isAddErrorClass">
            <el-table-column v-for="item of tableHead" :key="item.prop" :label="item.label" :width="item.width || 'auto'">
                <template slot-scope="scope">
                    <template v-if="item.prop">
                        <span>{{ scope.row[item.prop] }}</span>
                    </template>
                    <template v-else>
                        <div class="btn-container">
                            <router-link tag="span" class="btn" v-if="['异常'].includes(scope.row.results)" :to="{ name: 'reconciliation/list/detail', params: { id: scope.row.id } }">平账</router-link>
                            <!-- <span class="btn" @click="changeReconciliation(scope.row)" v-if="['异常'].includes(scope.row.results)"
                >重新对账</span
              > -->
                            <router-link tag="span" class="btn" v-if="['正常', '对账中'].includes(scope.row.results)" :to="{ name: 'reconciliation/list/detail', params: { id: scope.row.id } }">查看详情</router-link>
                            <div class="btn" v-if="scope.row.errorAmount!=='0.00'" @click="reconciling(scope.row)">重新对账</div>
                        </div>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <Pagination :params="params" @changeSize="changeSize" @changePage="changePage" />
        </div>
        <!-- </div> -->
    </div>
</template>

<script>
import { statements } from '@reconciliation/static/data.js';
import { mapGetters, mapActions } from 'vuex';
import queryForm from '@reconciliation/components/query-form.vue';
import searchBar from '@reconciliation/components/search-bar.vue';
import base from '@/api/base';
export default {
  name: 'list',
  computed: {
    ...mapGetters('reconciliat', ['tableData', 'params', 'rightListMap']),
  },
  provide() {
    return {
      submit: this.queryTableInfo,
      formList: statements.query_form_list,
      searchList: this.getSearchList,
      searchPlaceholder: statements.searchPlaceholder,
      downLoadExcel: this.downLoadExcel,
    };
  },
  components: {
    queryForm,
    searchBar,
  },
  data() {
    return {
      tableHead: statements.tableHead,
      form: {
        startTime: null,
        endTime: null,
        result1: null,
        result2: null,
      }, //查询参数
      searchVal: null, //搜索
      applyCode: '',
    };
  },
  methods: {
    ...mapActions('reconciliat', ['getReconciliatList', 'againReconciliation', 'reWriteBills']),
    // 条件查询
    queryTableInfo(form) {
      (this.form.startTime = form.datePicker.length > 0 ? form.datePicker[0].replace(/-/g, '') : null),
        (this.form.endTime = form.datePicker.length > 0 ? form.datePicker[1].replace(/-/g, '') : null),
        (this.form.result1 = form.result1 ? form.result1 : null);
      this.form.result2 = form.result2 ? form.result2 : null;
      this.getData();
    },
    isAddErrorClass({ row }) {
      return row.results === '异常' && 'error';
    },
    // 搜索
    getSearchList(item) {
      this.searchVal = item ? item : null;
      this.getData();
    },
    // 获取对账列表
    getData() {
      this.getReconciliatList({
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        applyCode: this.applyCode,
        batchNumber: this.searchVal,
        channel: this.form.result2,
        results: this.form.result1,
        pageNum: parseInt(this.params.pageNum),
        pageSize: parseInt(this.params.pageSize),
      });
    },
    // 修改条数
    changeSize(val) {
      this.params.pageSize = val;
      this.getData();
    },
    // 修改页数
    changePage(val) {
      this.params.pageNum = val;
      this.getData();
    },
    // 导出excel
    downLoadExcel() {
      window.location.href = `${base.baseUrl}/reconciliation/exportListByQuery?startTime=${
        this.form.startTime
      }&endTime=${this.form.endTime}&applyCode=${this.applyCode}&batchNumber=${this.searchVal}&channel=${
        this.form.result2
      }&results=${this.form.result1}&pageNum=${parseInt(this.params.pageNum)}&pageSize=${parseInt(
        this.params.pageSize,
      )}`;
    },
    // 重新对账
    async changeReconciliation(row) {
      await this.againReconciliation({
        applyCode: row.applyCode,
        billDate: row.contrastDate.replace(/-/g, ''),
        payChannel: row.channel === '微信' ? 'WECHAT' : row.channel === '支付宝' ? 'ALIPAY' : 'UNIONPAY',
      });
      await this.getData();
    },
    //重新对账
    async reconciling(row) {
      let params = {
        batchNumber: row.batchNumber,
        billDate: row.contrastDate,
        mchCode: row.applyCode,
        plantform: '',
      };
      switch (row.channel) {
        case '微信':
          params.plantform = 'WECHAT';
          break;
        case '支付宝':
          params.plantform = 'ALIPAY';
          break;
        case '汇付宝':
          params.plantform = 'HEEPAY';
          break;
        case '银联':
          params.plantform = 'UNIONPAY';
          break;
      }
      await this.reWriteBills(params);
      await this.getData();
    },
  },
  created() {
    this.$store.state.reconciliat.params.pageNum = 1;
    this.$store.state.reconciliat.params.pageSize = 10;
    this.applyCode = JSON.parse(localStorage.getItem('checkdApply')).applyCode;
    this.getData();
  },
};
</script>

<style lang="less" scoped>
@import '~@reconciliation/static/common.less';
// .btn-container {
//   .flex_layout(column, center, flex-start);
//   color: @primary-blue;
//   .btn {
//     cursor: pointer;
//   }
// }
/deep/.error {
  color: #ff5f5f;
}
.btn {
  cursor: pointer;
}
</style>
